export default class Session {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    customerID: 'validString',
    tenantID: 'validString',
    courseID: 'validString',
    courseProviderID: 'validString',
    id: 'validString',
    type: 'validString',
    templateID: 'validString',
    name: 'validString',
    internalName: 'validString',
    releaseType: 'validString',
    capacity: 'number',
    reservedCapacity: 'optionalNumber',
    minCapacity: 'validString',
    notificationDetails: 'any',
    internalNotes: 'optionalValidString',
    requiresInstructor: 'boolean?',
    requiresAdminReview: 'boolean?',
    askForReferrals: 'boolean?',
    hasMaterial: 'validString',
    content: 'any?',
    isPrivate: 'boolean',
    duration: 'number',
    venueID: 'validString',
    venueComplement: 'validString',
    considerFailues: 'boolean?',
    onlineAccessPeriod: 'optionalNumber',
    providerCourseTemplateID: 'validString',
    accessLink: 'validString',
    startDate: 'validString',
    endDate: 'validString',
    isMaterialSent: 'boolean',
    materialShippingInfo: 'validString',
    state: 'validString',
    onlineCourseID: 'validString',
    onlineGradeID: 'validString',
    onlineSetupID: 'validString',
    createdBy: 'any?',
    updatedBy: 'any?',
    updatedOn: 'any?',
    createdOn: 'any?',
    transactionID: 'any?',
  }
  */
  async createSession(sessionObj) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/session/new";
    req.body = sessionObj;
    return await req.exec();
  }
  async updateSession(sessionID, sessionObj) {
    const req = await this.api.newBaseRequest("PUT");
    req.path = "/session/" + sessionID;
    req.body = sessionObj;
    return await req.exec();
  }
  async deleteSession(sessionID) {
    const req = await this.api.newBaseRequest("DELETE");
    req.path = "/session/" + sessionID;
    return await req.exec();
  }
  async getSession(sessionID, expanded) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/session/" + sessionID + (expanded ? "?expanded=true" : "?expanded=false");
    return await req.exec();
  }
  async getSessionList(startTime, endTime, optionalCourseID, optExcludeOnline) {
    const req = await this.api.newBaseRequest("POST");
    if (optionalCourseID) req.path = "/session/events/" + startTime + "/" + endTime + "/" + optionalCourseID + (optExcludeOnline ? "?excludeOnline=true" : "");
    else req.path = "/session/events/" + startTime + "/" + endTime + "/" + (optExcludeOnline ? "?excludeOnline=true" : "");
    return await req.exec();
  }
  async getCustomerSessionList(startTime, endTime, optExcludeOnline) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/customer/session/events/" + startTime + "/" + endTime + "/" + (optExcludeOnline ? "?excludeOnline=true" : "");
    return await req.exec();
  }
  async transitionSessionState(sessionID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/session/" + sessionID + "/next/";
    return await req.exec();
  }
  async lockSession(sessionID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/session/" + sessionID + "/lock/";
    return await req.exec();
  }
  async unlockSession(sessionID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/session/" + sessionID + "/unlock/";
    return await req.exec();
  }
  async publishSession(sessionID, published) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/session/" + sessionID + "/publish/";
    req.body = { published };
    return await req.exec();
  }
  async cancelSession(sessionID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/session/" + sessionID + "/cancel/";
    return await req.exec();
  }
  async refreshSessionShippingInformation(sessionID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/session/" + sessionID + "/refreshShipping/";
    return await req.exec();
  }
  async releaseSession(sessionID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/session/" + sessionID + "/release/";
    req.body = publishObj;
    return await req.exec();
  }
  async updateSessionMaterialShipStatus(sessionID, shipFlag) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/session/" + sessionID + "/courseMaterial/";
    req.body = { materialShipped: shipFlag };
    return await req.exec();
  }
  async createSessionInstructor(sessionID, instructorID, instructorType) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/session/" + sessionID + "/instructor/" + instructorID;
    req.body = { instructorType };
    return await req.exec();
  }
  async updateSessionInstructor(sessionID, instructorID, instructorType) {
    const req = await this.api.newBaseRequest("PUT");
    req.path = "/session/" + sessionID + "/instructor/" + instructorID;
    req.body = { instructorType };
    return await req.exec();
  }
  async deleteSessionInstructor(sessionID, instructorID) {
    const req = await this.api.newBaseRequest("DELETE");
    req.path = "/session/" + sessionID + "/instructor/" + instructorID;
    return await req.exec();
  }
  async getSessionInstructor(sessionID, instructorID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/session/" + sessionID + "/instructor/" + instructorID;
    return await req.exec();
  }
  async createDocument(sessionID, file) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/session/" + sessionID + "/document";
    req.body = { ...file };
    return await req.exec();
  }
  async batchUpdateSessionAttendanceAndResults(sessionID, body) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/session/" + sessionID + "/attendances/results/batchUpsert";
    req.body = { ...body };
    return await req.exec();
  }
  async moveStudentSession(sessionID, userID, newSessionID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/session/" + sessionID + "/moveStudent/" + userID + "/" + newSessionID;
    return await req.exec();
  }
  async getSessionUserData(sessionID, userID, externalID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/session/" + sessionID + "/userData/" + userID + "/" + externalID;
    return await req.exec();
  }
  async duplicateSession(sessionID, duplicateObj) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/session/" + sessionID + "/duplicate";
    req.body = duplicateObj;
    return await req.exec();
  }
  async searchSessionsByIDs(ids) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/search/sessions/ids";
    req.body = { IDs: ids ? ids : [] };
    return await req.exec();
  }
}
